import { render, staticRenderFns } from "./editMemoDialog.vue?vue&type=template&id=52749184&scoped=true&lang=pug"
import script from "./editMemoDialog.vue?vue&type=script&lang=js"
export * from "./editMemoDialog.vue?vue&type=script&lang=js"
import style0 from "./editMemoDialog.vue?vue&type=style&index=0&id=52749184&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52749184",
  null
  
)

export default component.exports